<template>
  <div class="positive-negative-bar-chart-small-node">
    <div class="positive-negative-bar-chart-small-container">
      <svg ref="chart" class="pigeondoc-chart positive-negative-bar-chart-small"></svg>
    </div>
    <div class="positive-negative-bar-chart-small__desc">
      <slot name="description" :chartDescription="chartDescription">
        <details>
          <summary>Chart Description</summary>
          <p>{{ chartDescription }}</p>
        </details>
      </slot>
    </div>
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
import Chart from './chart.js';

export default {
  name: 'PositiveNegativeBarChartSmall',
  props: {
    value: PigeonDocNodeModel,
  },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    chartDescription: function () {
      return this.value.meta.description;
    },
  },
  mounted() {
    this.createChart();
  },
  watch: {
    value() {
      this.renderChart();
    },
  },
  methods: {
    createChart() {
      this.chart = new Chart(this.$refs['chart'], this.value.content.data, this.value.content.meta);
      this.chart.createChart();
    },
    renderChart() {
      this.chart.empty();
      this.$nextTick(
        function () {
          this.createChart();
        }.bind(this),
      );
    },
  },
};
</script>

<style>
.positive-negative-bar-chart-small-node {
  width: 300px;
  margin: 0 auto;
}

.positive-negative-bar-chart-small-container {
  overflow: auto;
}

.positive-negative-bar-chart-small-node svg {
  width: 100%;
}

.positive-negative-bar-chart-small__desc {
  cursor: pointer;
  font-size: 0.85rem;
  line-height: 1.5;
  margin: 0.75rem 0;
  text-align: right;
}
</style>
